import { createSelector } from 'reselect';

const getBatchesCars = (state, props) => state.carsBatch.cars;

export const makeGetFilteredCars = () =>
    createSelector([getBatchesCars], cars =>
        cars.reduce(
            (acc, curr) =>
                curr.IsBlocked
                    ? {
                          ...acc,
                          unavailableCars: [...acc.unavailableCars, curr],
                      }
                    : { ...acc, availableCars: [...acc.availableCars, curr] },
            {
                availableCars: [],
                unavailableCars: [],
            }
        )
    );
